import React from 'react'
import { StyledLanguage, BackButton, LanguageDiv, ContainerBackButton } from './index.styled'
import { IoIosArrowRoundBack } from 'react-icons/io'
import { FormattedMessage } from 'react-intl'
const languages = require('../../assets/mock-data/languages.json')

const LanguagesComponent = ({ selectedLanguage = languages[0], updateShowLanguage, updateSelectedLanguage }) => {

  const changeLanguage = (lang) => {
    updateSelectedLanguage(lang.value);
    updateShowLanguage(false);
  }

  return (
    <>
    <ContainerBackButton>
      <BackButton onClick={() => updateShowLanguage(false)}>
        <IoIosArrowRoundBack /><p><FormattedMessage id="back" /></p>
      </BackButton>
    </ContainerBackButton>
    <LanguageDiv>
      {
        languages.map((lang, i) => (
          <StyledLanguage
            evidence={selectedLanguage.value === (lang.value || 'en')}
            onClick={()=> changeLanguage(lang)}
            className={selectedLanguage.value === (lang.value || 'en') ? 'active' :''}
            key={i}
          >
            {lang.label}
          </StyledLanguage>
        ))
      }
    </LanguageDiv>
    </>
)};

export default LanguagesComponent